module.exports = __webpack_public_path__ + "static/media/rocket_launch.ee71df3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/rocket_launch.png
// module id = 124
// module chunks = 0